<template>
    <div>
        <modals-container @importCategories="passImportCategories" @updateCategoryName="passUpdateCategoryName" @confirmRemoveRow="confirmRemoveRow"
                          @budgetDone="passBudgetDone" @confirmCategory="confirmCategory" @addCategory="passAddCategory"
                          id="delete-row-modal"
                          @confirmRemoveDocument="passConfirmRemoveDocument"></modals-container>
        <div class="row">
            <div class="col-md-12">
                <table class="table table-bordered invoice-table">
                    <thead>
                    <tr>
                        <th>{{$t('message.date')}}</th>
                        <th>{{$t('message.descriptionInvoiceNumber')}}</th>
                        <th colspan="2">{{$t('message.amountChfExclVat')}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(line, index) in computedInvoicedLines" :key="index">
                        <td><span v-if="line.show">{{line.date}}</span></td>
                        <td><input class="table-input" v-model="line.description" style="background-color: #c1fca9"
                                   type="text"></td>
                        <td>
                            <input class="table-input" v-model="line.amount" 
                                   type="number">
                        </td>
                        <td style="position: relative; vertical-align: middle;">
                            <div style="width: 100%">
                                <div @click="removeRow(line)"
                                     :class="{'add-row-same-date': true, 'remove-row-same-date': true}">
                                    -
                                </div>
                                <div @click="addRowWithSameDate(line.date, false)" :class="{'add-row-same-date': true}">
                                    +
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div style="width: 100%" class="text-center">
                <button @click="addRowWithNewDate" class="btn btn-success">{{$t('message.addRowWithNewDate')}}</button>
                <button @click="updateData" class="btn btn-primary ml-3">{{$t('message.update')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
  import DialogModal from '../../modals/DialogModal'
  import OkModal     from '../../modals/OkModal'

  export default {
    data () {
      return {
        invoicedLines: [],
        unsavedWork: false
      }
    },
    props: ['sheet'],
    created () {
      this.getList(this.apiPrefix, this.invoicedAmountsUrl + `?sheet_id=${this.$route.params['id']}`)
        .then(resp => {
          this.invoicedLines = resp.data
        }).catch(err => {
        console.log(err.response)
      })
    },
    methods: {
      calculateTotaleInvoiced () {
        return this.invoicedLines.map(row => parseFloat(row.amount)).reduce((prev, next) => {
          next = prev + next
          return next
        }, 0)
      },
      updateData () {
        this.update(this.apiPrefix, this.invoicedAmountsUrl + 'bulk-update/', `${this.$route.params['id']}`, {
          'invoicedAmounts': this.invoicedLines,
          'totalInvoiced': this.calculateTotaleInvoiced()
        }).then(resp => {
          this.invoicedLines = resp.data
          this.$emit('totalInvoiced', this.calculateTotaleInvoiced())
          this.unsavedWork = false;

          this.$modal.show(OkModal, {
              text: this.$t('message.invoiceLineAdded'),
              modalClass: this.modalClasses.okSuccessClass
            },
            {
              width: this.modalWidth(),
              height: 'auto'
            })

        }).catch(err => {
          console.log(err.response)

          this.$modal.show(OkModal, {
              text: this.$t('message.oopsSomethingWentWrong'),
              modalClass: this.modalClasses.okErrorClass
            },
            {
              width: this.modalWidth(),
              height: 'auto'
            })

        })
      },
      confirmRemoveRow (data) {
        this.unsavedWork = true
        this.showTrueRowDeleted(data, 'id')
        this.delete(this.apiPrefix, this.invoicedAmountsUrl, data.id).then(() => {
          this.invoicedLines = this.invoicedLines.filter(row => row.id !== data.id)
          this.unsavedWork = false;
        })
      },
      removeRow (line) {
        if (line['id']) {
          this.$modal.show(DialogModal, {
              text: `${this.$t('message.deleteCostRow')}.`,
              param: line,
              textColor: '#c44133',
              event: 'confirmRemoveRow'
            },
            {
              width: this.modalWidth(),
              height: 'auto'
            })
        } else {
          this.showTrueRowDeleted(line, 'uuid')
          this.invoicedLines = this.invoicedLines.filter(row => row['uuid'] !== line['uuid'])
        }
      },
      addRowWithNewDate () {
        if (!this.invoicedLines.length) {
          const date = this.$moment(this.sheet.start_date).format(this.formatBackendString)
          const row = this.createRow(this.$moment(date).format(this.formatBackendString), 1)
          this.invoicedLines.push(row)
        } else {
          const date = this.$moment(this.invoicedLines[this.invoicedLines.length - 1].date).add(1, 'M').format(this.formatBackendString)
          const row = this.createRow(this.$moment(date).format(this.formatBackendString), 1)
          this.invoicedLines.push(row)
        }
      },
      addRowWithSameDate (date) {
        const row = this.createRow(this.$moment(date).format(this.formatBackendString), 0)
        const index = this.reverseFindByProperty(this.invoicedLines, 'date', date)
        this.invoicedLines.splice(index + 1, 0, row)
      },
      createRow (date, show) {
        return {
          'date': date,
          'amount': 0,
          'show': show,
          'sheet_id': this.sheet.id,
          'uuid': this.uuidv4()
        }
      },
      showTrueRowDeleted (row, prop) {
        if (row.show) {
          let index = this.findByProperty(this.invoicedLines, prop, row[prop])
          console.log(index)

          if (this.invoicedLines[index] && this.invoicedLines[index].show) {
            if (!(typeof this.invoicedLines[index + 1] === 'undefined') && !this.invoicedLines[index + 1].show) {
              this.invoicedLines[index + 1].show = true
            }
          }
        }
      }
    },
    computed: {
      computedInvoicedLines () {
        return this.invoicedLines
      }
    },
    beforeRouteLeave (to, from, next) {
      if (this.unsavedWork) {
        const answer = window.confirm(this.$t('message.leavePage'))
        if (answer) {
          this.updateData()
          next()
        } else {
          next(false)
        }
      } else {
        next()
      }
    }
  }
</script>

<style>
    .invoice-table {
        font-size: 0.85em;
    }

    .invoice-table th {
        padding: 5px;
    }

    .invoice-table td {
        padding: 5px;
        max-height: 20px;
    }

    .add-row-same-date {
        background-color: #0b93d5;
        color: white;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        border: 3px solid white;
        width: 30px;
        text-align: center;
        font-size: 1.2em;
        cursor: pointer;
    }

    .remove-row-same-date {
        background-color: #e74c3c;
        position: absolute;
        right: 30px;
        top: 0;
    }

    .table-input {
        width: 100%;
        border: medium none;
        vertical-align: middle;
        height: 20px;
    }
</style>
